import {
  CAMPAIGN_CREATE,
  CAMPAIGN_DETAIL,
  ACTION_ID,
  CAMPAIGN_RESET
} from '../actionTypes/campaign'

export const BASE_CAMPAIGN = {
  requester_email: "",
  creation_date: "",
  flow: "",
  campaign: {
    name: "",
    cashback_percentage: null,
    partner_cashback_percentage: 0,
    sponsor_cashback_percentage: 0,
    loyalty_points: null,
    start_date: "",
    start_time: "00:01",
    end_date: "",
    end_time: "23:59",
    minimum_order_value: null,
    recurrence_days: [],
    skus: [],
    payment_methods: []
  },
  stores: {
    economic_group: [],
    head_offices: [],
    branches: []
  }
}

const INITIAL_STATE = {
  create: BASE_CAMPAIGN,
  detail: {},
  resultCampaign: {
    name: "",
    actionId: ""
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CAMPAIGN_CREATE:
      return { ...state, create: action.payload }

    case CAMPAIGN_DETAIL:
      return { ...state, detail: action.payload }

    case ACTION_ID:
      return {
        ...state,
        resultCampaign: action.payload.resultCampaign,
        detail: action.payload.detail,
      }

    case CAMPAIGN_RESET:
      return { ...state, create: BASE_CAMPAIGN }

    default:
      return state
  }
}
